import React from "react";

import { Row, Col} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import {PlusOutlined } from '@ant-design/icons';
import { Player } from 'video-react';
import videoPoster from "../../Imgs/HomePage/videoPoster.jpg";
import videoPoster1 from "../../Imgs/HomePage/videoPoster1.jpg";

// CSS Files
import "../../../../node_modules/video-react/dist/video-react.css";
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Introduction.css";

const Introduction = props => {
     return props.size === "laptopdesktop" ? (
            <div style={{ backgroundColor: "#f6f6f6" }}>
                <Row>
                    <Col span={3}></Col>
                    <Col span={8}>
                        <Margin top={5}></Margin>
                        <div className="videoDashBorder" style={{marginTop:"100px"}}>
                            <img className="videoStyle" src={videoPoster1}/>
                        </div>
                        <Margin bottom={5}></Margin>
                    </Col>
                    <Col span={1}></Col>
                    <Col span={9}>
                        <Margin top={5}></Margin>
                        <h4 style={{ fontFamily: "IRANSans", color: "#ed1c24" , direction:"rtl" , textAlign:"right" , marginTop:"10px"}}><strong>ایرانیان پوشش</strong></h4>
                        <Margin top={3}></Margin>
                        <h5 style={{ fontFamily: "IRANSans", color: "#ed1c24", marginTop:"-10px" , textAlign:"right"}}><strong>شعار ما: مراقب بیمه ( حافظ رابطه بیمه گر و   بیمه گذار )</strong></h5>
                        <Margin top={3}></Margin>
                        <p className="textParagraph">
                        اهداف این هلدینگ تاسیس و راه اندازی 12 شرکت از قبیل موسسه  ارزیابی خسارت ، ریسک، ایمنی،  آکچوئری، داده کاوی،  آموزش ، پژوهش ، ریکاوری ، داوری، رسانه ، تحقیق ، بازرسی ، حسابرسی ،وکالت وحقوقی ،مشاوره ،  امداد و نجات ، تکنولوژی وفن آوری اطلاعات  و تمام خدمات تخصصی به جز فروش بیمه می باشد. ایرانیان پوشش  با شعار پر صلابت مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار) رسما آغاز به کار کرد و از همان ابتدا،تضمین حقوق بیمه گر و   بیمه گذار، را سرلوحه خدمات خود قرار دادیم.

                        </p>
                        <div style={{textAlign:"right"}}>
                        <Margin top={3}>
                             <a href="/aboutus" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".8em", fontFamily: "IRANSans" }}><PlusOutlined style={{color:"#fff"}} /> مطالعه بیشتر</a>
                        </Margin>
                        </div>
                        <Margin bottom={3}></Margin>
                    </Col>
                    <Col span={4}></Col>
                </Row>
            </div>
     ) : props.size === "tablet" ? (
            <div style={{ backgroundColor: "#f6f6f6" }}>
                <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <Margin top={2}>
                            <p style={{ fontFamily: "IRANSans", color: "#ed1c24", direction: "rtl", textAlign: "right", fontSize: "1.05em" }}><strong>ایرانیان پوشش</strong></p>
                        </Margin>
                    </Col>
                    <Col span={1}></Col>
                </Row>
                <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <p style={{ fontFamily: "IRANSans", color: "#ed1c24", direction: "rtl", textAlign: "right", fontSize: "1em"  , marginTop:"-10px"}}><strong>شعار ما: مراقب بیمه ( حافظ رابطه بیمه گر و   بیمه گذار )</strong></p>
                    </Col>
                    <Col span={1}></Col>
                </Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <p className="textParagraphTablet">
                                اهداف این هلدینگ تاسیس و راه اندازی 12 شرکت از قبیل موسسه  ارزیابی خسارت ، ریسک، ایمنی،  آکچوئری، داده کاوی،  آموزش ، پژوهش ، ریکاوری ، داوری، رسانه ، تحقیق ، بازرسی ، حسابرسی ،وکالت وحقوقی ،مشاوره ،  امداد و نجات ، تکنولوژی وفن آوری اطلاعات  و تمام خدمات تخصصی به جز فروش بیمه می باشد. ایرانیان پوشش  با شعار پر صلابت مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار) رسما آغاز به کار کرد و از همان ابتدا،تضمین حقوق بیمه گر و   بیمه گذار، را سرلوحه خدمات خود قرار دادیم.
                        </p>
                    </Col>
                    <Col span={2}></Col>
                </Row>
                <Row>
                    <Col span={3}></Col>
                    <Col span={18}>
                        <div className="videoDashBorder">
                        <img className="videoStyle" src={videoPoster1}/>

                        </div>
                        <Margin bottom={4}></Margin>
                    </Col>
                    <Col span={3}></Col>
                </Row>
            </div>
     ) : (
            <div style={{ backgroundColor: "#f6f6f6" }}>
                <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <Margin top={2}>
                            <p style={{ fontFamily: "IRANSans", color: "#ed1c24", direction: "rtl", textAlign: "right", fontSize: ".95em" }}><strong>ایرانیان پوشش</strong></p>
                        </Margin>
                    </Col>
                    <Col span={1}></Col>
                </Row>
                <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <p style={{ fontFamily: "IRANSans", color: "#ed1c24", direction: "rtl", textAlign: "right", fontSize: ".825em"  , marginTop:"-10px"}}><strong>شعار ما: مراقب بیمه ( حافظ رابطه بیمه گر و   بیمه گذار )</strong></p>
                    </Col>
                    <Col span={1}></Col>
                </Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <p className="textParagraphMobile">
                                اهداف این هلدینگ تاسیس و راه اندازی 12 شرکت از قبیل موسسه  ارزیابی خسارت ، ریسک، ایمنی،  آکچوئری، داده کاوی،  آموزش ، پژوهش ، ریکاوری ، داوری، رسانه ، تحقیق ، بازرسی ، حسابرسی ،وکالت وحقوقی ،مشاوره ،  امداد و نجات ، تکنولوژی وفن آوری اطلاعات  و تمام خدمات تخصصی به جز فروش بیمه می باشد. ایرانیان پوشش  با شعار پر صلابت مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار) رسما آغاز به کار کرد و از همان ابتدا،تضمین حقوق بیمه گر و   بیمه گذار، را سرلوحه خدمات خود قرار دادیم.
                        </p>
                    </Col>
                    <Col span={2}></Col>
                </Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div className="videoDashBorder">
                        <img className="videoStyle" src={videoPoster1}/>

                        </div>
                        <Margin bottom={4}></Margin>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>
          );
};

export default Introduction;
